export const CURRENT_STATEMENT_SUMMARY = [
  {
    label: "Total Balance",
    key: "OutstandingBalance",
    location: "accounting",
    type: "currencyPrecise",
    defaultValue: "0"
  },
  {
    label: "Past Due Balance",
    key: "PastDueBalance",
    location: "accounting",
    type: "currencyPrecise",
    defaultValue: "0"
  },
  {
    label: "Invoice Amount",
    key: "InvoiceAmountCurrent",
    location: "accounting",
    type: "currencyPrecise",
    defaultValue: "0"
  },
  {
    label: "Minimum Payment",
    key: "MinimumPaymentDue",
    location: "accounting",
    type: "currencyPrecise",
    defaultValue: "0"
  },
  {
    label: "Payment Due Date",
    key: "InvoiceDueDateCurrent",
    location: "accounting",
    type: "date"
  },
  {
    label: "Most Recent Invoice",
    key: "InvoiceDateCurrent",
    location: "accounting",
    type: "date"
  }
];

export const ACCOUNT_ACTIVITY_VALUES = {
  POLICY_ISSUED_NEW_BUSINESS: "New Business Policy Issued",
  INSTALLMENT_CHARGE: "Installment Charge",
  PAYMENT: "Payment",
  DISBURSE: "Disbursement",
  REVERSE_DISBURSE: "Reverse Disbursement",
  ENDORSE: "Endorsement",
  WRITE_OFF_CHARGE: "Charge Write Off",
  REVERSE_UNCOLLECTIBLE_CREDIT: "Reverse Uncollectible Credit",
  UNCOLLECTIBLE_CREDIT: "Uncollectible Credit",
  LATE_PAYMENT_CHARGE: "Late Payment Charge",
  REVERSE_PAYMENT: "Reverse Payment",
  CANCEL: "Cancel",
  REINSTATE: "Reinstate"
};

export const PAYMENT_ACTIVITY_VALUES = {
  0: "Transfer",
  200: "Check",
  300: "ACH",
  400: "Credit Card",
  ach: "ACH",
  creditcard: "Credit Card"
};

export const PAYMENT_INFORMATION = [
  {
    label: "Payor",
    key: accounting => accounting.Payor.OpPayorName,
    location: "accounting"
  },
  {
    label: "Payment Plan",
    key: accounting => accounting.PaymentPlan.type,
    location: "accounting",
    type: "payplan"
  },
  {
    label: "Next Payment Due Date",
    key: "InvoiceDueDateNext",
    location: "accounting",
    type: "date"
  },
  {
    label: "Next Payment Amount",
    key: "InvoiceAmountNext",
    location: "accounting",
    type: "currencyPrecise",
    defaultValue: "0"
  }
];

export const POLICYSTATE_LABELS = {
  ACTIVEPOLICY: "Active",
  CANCELLEDPOLICY: "Cancelled",
  NONRENEWEDPOLICY: "Non-Renewed",
  TRANSFERREDPOLICY: "Transferred"
};

export const POLICYSTATUS_LABELS = {
  PendingCancellation: "Pending Cancellation",
  PendingNonRenewal: "Pending Non-Renewal"
};

export const MORTGAGEE_INFORMATION = [
  { label: "Primary Mortgagee", key: "MortgageeNumber1" },
  {
    label: "Primary Address",
    key: {
      $1: "Mortgagee1AddressLine1",
      $2: "Mortgagee1AddressLine2",
      $3: "Mortgagee1AddressCity",
      $4: "Mortgagee1AddressState",
      $5: "Mortgagee1AddressZip"
    },
    template: "$1 $2 $3, $4 $5"
  },
  { label: "Primary Loan Number", key: "LoanNumber1" },
  { label: "Secondary Mortgagee", key: "MortgageeNumber2" },
  {
    label: "Secondary Address",
    key: {
      $1: "Mortgagee2AddressLine1",
      $2: "Mortgagee2AddressLine2",
      $3: "Mortgagee2AddressCity",
      $4: "Mortgagee2AddressState",
      $5: "Mortgagee2AddressZip"
    },
    template: "$1 $2 $3, $4 $5"
  },
  { label: "Secondary Loan Number", key: "LoanNumber2" }
];

export const HEADERS = [
  {
    name: "Payment Information",
    context: PAYMENT_INFORMATION
  },
  {
    name: "Billing Summary",
    context: [
      {
        label: ({ TotalPremiumLabel = "Premium" }) =>
          `Last Updated ${TotalPremiumLabel}`,
        key: "TotalPremium",
        type: "currencyPrecise"
      },
      {
        label: "Total Balance",
        key: "OutstandingBalance",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Invoice Amount",
        key: "InvoiceAmountCurrent",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Minimum Payment",
        key: "MinimumPaymentDue",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Payment Due Date",
        key: "InvoiceDueDateCurrent",
        location: "accounting",
        type: "date"
      }
    ]
  }
];

// Policy Vew Sections and ordering
// This is done in Launch Darkly now, but this is here as a fall back
export const SECTIONS = [
  {
    id: "overview",
    title: "Policy Overview"
  },
  {
    id: "billing",
    title: "Billing"
  },
  {
    id: "documents",
    title: "Documents"
  },
  {
    id: "settings-and-offers",
    title: "Settings and Offers",
    show: "policy-settings-and-offers"
  },
  {
    id: "claims",
    title: "Claims"
  },
  {
    id: "inspection",
    title: "Inspection",
    hide: "policy-view-underwriting-review"
  },
  {
    id: "underwriting-review",
    title: "Underwriting Review",
    show: "policy-view-underwriting-review"
  },
  {
    id: "docusign",
    title: "eSign Document Status",
    show: "policy-view-docusign"
  },
  {
    id: "notes",
    title: "Notes"
  },
  {
    id: "activity",
    title: "Policy Activity"
  }
];
